import { ol_Feature } from "@omnia/exports/openlayers"
import { FieldViewModel } from "../../omnia"
import { Dispatch } from "../actions"
import { TerramapContext } from "../context"
import { parseFieldKey } from "../fields"
import { SelectionField, SelectionGroup } from "../types"
import { MapContext } from "./mapContext"

export function useMapSelection(mapContext: MapContext, groups: SelectionGroup[], selectedFieldKey: string) {

    const { dispatch } = React.useContext(TerramapContext)

    const fieldId = parseFieldKey(selectedFieldKey)

    const map = mapContext?.map

    React.useEffect(() => {

        if (!map) {
            return
        }

        selectCurrentField(map, fieldId)

        return watchSelection(map, dispatch, groups)

    }, [dispatch, map, groups, fieldId])

}

function selectCurrentField(map: MapContext["map"], fieldId: number) {

    const currentId = getFieldIdFromFeatures(map.getSelectedFeatures())

    if (currentId != fieldId) {
        const fieldFeature = map.fieldsLayer.findField(fieldId)
        map.selectFeatures(fieldFeature ? [fieldFeature] : [])
    }

}

function watchSelection(map: MapContext["map"], dispatch: Dispatch, groups: SelectionGroup[]): () => void {

    const cleanup = map.watchSelection(features => {

        const fieldId = getFieldIdFromFeatures(features)

        if (fieldId) {

            const match = findFirstFieldWithId(groups, fieldId)

            if (match) {
                dispatch({ type: "setSelectedField", fieldKey: match.key })
            }

        }

    })

    return () => cleanup()


}

function getFieldIdFromFeatures(features: ol_Feature[]) {

    if (features?.length !== 1) {
        return
    }

    const field = features[0].get("data") as FieldViewModel

    return field?.fieldId

}

function findFirstFieldWithId(groups: SelectionGroup[], fieldId: number): SelectionField {

    const match = groups.map(g => g.fields.find(f => f.fieldId === fieldId)).find(f => !!f)

    return match

}
